<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        Monitore setores
        <span v-if="loading && totalSectorsCategory">
          ... {{loadedSectorsPercentage}}%
        </span>
      </h3>

      <!-- TODO -->
      <!-- CORRIGIR A QUERY QUE TE NÃO TA RETORNANDO A MEDIA DO ATUADOR NA AGENDA -->

      <toolbar
        v-if="mobile"
        :is-mobile="mobile"
        :filter-opt="filterOpt"
        :is-filtering="isFiltering"
        type="sectors"
        @search="inputSearch"
        @clear-search="clearSearch"
        :type-filtering="typeFiltering"
        :is-searching="isSearching"
        :not-exists="notExists"
        :not-search="notSearch"
      /> 

      <div
        v-if="!loading && !fullList.length && !sectorsFilters.values.filterStatus"
        class="
          EmptyRequest
          w-100
          p-0
          row
          center-xs center-md center-sm center-xs
          mt-3
        "
      >
        <img :src="emptyIcon" class="empty" />
        <span
          >Não há setores de manejo para exibir. Para cadastrar um novo,
          <router-link to="/registers/sectors">clique aqui</router-link></span
        >
      </div>
      <div
        v-else-if="!loading && sectorsFilters.values.filterStatus && !itemsShowing.length"
        class="col-xs-12 center-xs mt-5"
      >
        Não foram encontrados setores para esta busca
      </div>

      <div class="container-cards">
        <!-- MANAGEMENT CARDS  -->
        <management-sector-card
          v-for="(item, index) in itemsShowing"
          :key="index"
          :item="item"
          :is-selected="selectedCard == index"
          :loading-progress="item.isLoading ? loadedSectorsPercentage : 100"
          :card-click-handler="() => managementClickHandler(item, index)"
          :bg-class-status="BGRF(item.RF_STAT, item.UPDATE)"
        />
      </div>
    </div>

    <!-- BARRA DIREITA -->
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <sector-icon title="" customHeight="20px" />
            <div class="title-monit-helper">
              Monitore Setores
            <span v-if="loading && totalSectorsCategory">
              ... {{loadedSectorsPercentage}}%
            </span>
            </div>
          </div>
        </header>
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Setores</h5>
            <span>{{ fullList.length }}</span>
          </div>

          <toolbar
            v-if="!mobile"
            :is-mobile="mobile"
            :filter-opt="filterOpt"
            :is-filtering="isFiltering"
            @search="inputSearch"
            @clear-search="clearSearch"
            :type-filtering="typeFiltering"
            :is-searching="isSearching"
            :not-exists="notExists"
            :not-search="notSearch"
            class="mb-3 h2"
          /> 

          <div>
            <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
              Ordenar Por:
            </div>
            <b-form-select v-model="selectedSortBy">
              <option :value="null">
                Status
              </option>
              <option value="NAME">
                Nome
              </option>
            </b-form-select>
          </div>

          <div>
            <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
              Filtrar Por Tipo de Setor:
            </div>

            <b-form-select :disabled="loading" class="px-3" v-model="sectorsFilters.values.filterSectorType">
              <option :value="null">
                Todos ativos
              </option>

              <option
                v-for="filter in sectorsFilters.categories.filter(item => item.type === 'sector')"
                :name="filter.text"
                :value="filter.text"
                :key="filter.text"
              >
                <span class="px-2 text-center flex-grow-1">
                  {{filter.text}}s
                  (
                    <span v-if="filter.value === 'Inativo'">{{ totalInactiveSectorsCount }}</span>
                  <span v-else-if="filter.value === 'Colhido'">{{totalCropedSectors}}</span>
                  )
                </span>
              </option>
            </b-form-select>
          </div>

          <div>
            <div class="label ml-2 mr-2 mt-3" v-if="!mobile && options.length">
              Filtrar Por Usuários:
            </div>
            <div class="ml-2 mr-2 mt-0 mb-0">
              <b-form-group v-if="!mobile" class="wrapper-users-filters mb-0">
                <b-form-checkbox-group
                  v-model="selectedCheckbox"
                  id="checkbox-group-1"
                  :options="options"
                  name="filters"
                  button-variant="info"
                  size="sm"
                  class="options"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          
          <div>
            <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
              Filtrar Por Status:
            </div>

            <b-form-select class="px-3" v-model="sectorsFilters.values.filterStatus">
              <option :value="null">
                Todos
              </option>

              <option
                v-for="filter in sectorsFilters.categories.filter(item => item.type === 'status')"
                :name="filter.text"
                :value="filter.text"
                :key="filter.text"
              >
                <span class="px-2 text-center flex-grow-1">
                  {{filter.text}}
                  (<span>
                    {{
                      itemsShowing.filter(sector => sector.STATUS && sector.STATUS.includes(filter.text)).length
                    }}
                  </span>)
                </span>
              </option>
            </b-form-select>
          </div>

          <div>
            <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
              Filtrar Por Equipamentos:
            </div>

            <b-form-select class="px-3" v-model="sectorsFilters.values.filterEquipment">
              <option :value="null">
                Todos
              </option>

              <option
                v-for="filter in sectorsFilters.categories.filter(item => item.type === 'equipment')"
                :name="filter.text"
                :value="filter.text"
                :key="filter.text"
              >
                <span class="px-2 text-center flex-grow-1">
                  {{filter.text}}
                  (<span>
                    {{
                      itemsShowing.filter(sector => {
                        if(!filter.value) {
                          return true;
                        }

                        return sector.STATUS && sector.STATUS.includes(filter.text);
                      }).length
                    }}
                  </span>)
                </span>
              </option>
            </b-form-select>
          </div>

          <div>
            <div class="label ml-2 mr-2 mt-3" v-if="!mobile && farmOptions.length">
              Filtrar Por Cultivar:
            </div>
            <div class="ml-2 mr-2 mt-0 mb-0">
              <b-form-group v-if="!mobile" class="wrapper-users-filters mb-0">
                <b-form-checkbox-group
                  v-model="selectedFarmNames"
                  id="checkbox-group-farms"
                  :options="farmOptions"
                  name="farm-filters"
                  button-variant="info"
                  size="sm"
                  class="options"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <sector-details
      v-if="selected"
      :item="selected"
      :updated="updated"
      :bg-status="selected.STATUS_COLOR"
      :editor="editorName"
      :is-mobile="mobile"
      :show-details="showDetails"
      @close-details="closeDetails"
    />
  </div>
</template>

<script>
import SearchName from "./components/SearchName.vue"
import ManagementSectorCard from "./components/ManagementSectorCard.vue";
import { management } from "@/api";
import {
  updateFormatter,
  calcPercentageRounded,
} from "@/pages/components/helpers";
import SectorDetails from "@/pages/monitoringPages/Sectors/components/SectorDetails";
import moment from "moment";

export default {
  mixins: [
    SearchName,
  ],
  props: {
    mobile: Boolean,
  },
  components: {
    SectorDetails,
    ManagementSectorCard,
  },
  data() {
    return {
      totalSectorsCategory: 0,
      limitSliceRequest: 50,
      loadedSectorsCategory: 0,
      statusOrderSector: {
        critico: 0,
        abaixo: 1,
        na_faixa: 2,
        colhido : 3,
        desatualizado: 4,
        loading: 5,
      },
      selectedSortBy: null,
      managementSectorsBasic: [],
      totalCropedSectors: [],
      activeSectors: [],
      cropedSectors: [],
      inactiveSectors: [],
      totalInactiveSectorsCount: 0,
      totalSectorsCategory: 0,
      schedulesRunningToday: [],
      cardsData: [],
      showDetails: false,
      backendNow: null,
      loading: true,
      selected: null,
      selectedCard: null,
      missingResults: false,
      emptySensors: false,
      isAllSelected: "",
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      type: null,
      optionsLeft: [],
      fullList: [],
      loadingInactives: false,
      loadingFilters: false,
      filterBy: null,
      textInputSearch: "",
      windPoints: {},
      timeout: null,
      checkboxList: [],
      selectedCheckbox: [],
      selectedFarmNames: [],
      sectorsFilters: {
        values: {
          filterStatus: null,
          filterEquipment: null,
          filterSectorType: null,
        },
        categories: [
          { value: "Na faixa", text: "Na faixa", type: "status" },
          { value: "Abaixo", text: "Abaixo", type: "status"  },
          { value: "Crítico", text: "Crítico", type: "status"  },
          { value: "Desativado", text: "Desativado", type: "status" },
          { value: "Colhido", text: "Colhido", type: "sector" },
          { value: "Inativo", text: "Inativo", type: "sector" },
          { value: "Desatualizado", text: "Desatualizado", type: "status"  },
          { value: "Sem válvula", text: "Sem válvula", type: "status"  },
          { value: "Excedente", text: "Excedente", type: "status"  },
          { value: "Com Sensor", text: "Com Sensor", type: "equipment"  }
        ]
      },
    };
  },
  async created() {
    const counts = await management.getSectorsMonitoringCounts();
    this.totalInactiveSectorsCount = counts.inactive;
    this.totalCropedSectors = counts.croped;

    this.$emit(
      "title-change",
      this.mobile ? "M. de Setores" : "Monitoramento de Setores"
    );

    this.monitLoop();

    if (!this.type) {
      this.isAllSelected = true;
    }

  },
  watch: {
    async 'sectorsFilters.values.filterSectorType' (value) {
      this.sectorsFilters.values.filterStatus = null;

      if(value === "Inativo" && !this.inactiveSectors.length) {
        this.loading = true;
        await this.getInactiveSectors();
        this.loading = false;

      } else if(value === "Colhido" && !this.cropedSectors.length) {
        this.loading = true;
        await this.getCropedSectors();
        this.loading = false;

      }

      if(!value) {
        this.fullList = this.activeSectors;

      } else if(value === "Inativo") {
        this.fullList = this.inactiveSectors;

      } else if(value === "Colhido") {
        this.fullList = this.cropedSectors;

      }
    },
  },
  methods: {
    calcPercentageRounded,
    formatUpdate(update) {
      return updateFormatter(update);
    },
    async getInactiveSectors () {
      this.totalSectorsCategory = this.totalInactiveSectorsCount;
      this.loadedSectorsCategory = 0;
      this.loadedSectorsCategory += this.totalSectorsCategory/2;

      const inactiveSectors = await management.getSectorsMonitoringSkeleton({ type: 'inactive' });

      this.inactiveSectors = inactiveSectors
        .map((sector) => {
          sector.isLoading = false;
          sector.STATUS = ["Inativo"];
          sector.STATUS_COLOR = "bg-grey";
          sector.FARM = { NAME: sector.PLANTING_TYPE || '...' };
          sector.inative_days = Math.ceil(moment().diff(moment(sector.UPDATE).format("YYYY-MM-DD"), 'days'));

          return sector;
        });
      
      this.loadedSectorsCategory += this.totalSectorsCategory/2;
    },
    async getCropedSectors() {
      this.totalSectorsCategory = this.totalInactiveSectorsCount;
      this.loadedSectorsCategory = 0;

      const basicCropedSectors = await management.getSectorsMonitoringSkeleton({ type: 'croped' });

      this.totalSectorsCategory = this.totalCropedSectors;

      basicCropedSectors.map((sector) => {
        sector.isLoading = true;

        return sector;
      })

      const totalPages = Math.ceil(this.totalCropedSectors / this.limitSliceRequest);

      await Promise.all([...Array(totalPages).keys()]
        .map(async(index) => {
          const page = index + 1;

          const cropedSectors = await management
            .getSectorsMonitoringPage({page, limit: this.limitSliceRequest, isCroped: true})

          this.loadedSectorsCategory += cropedSectors.length;

          cropedSectors
            .map(sector => {
              this.getStatus({sector, isCroped: true});
              sector.isLoading = false;

              return sector;
            });

          this.cropedSectors.push(...cropedSectors);
        }))
    },
    managementClickHandler(sector, index) {
      if(sector.isLoading) {
        return alert(`Reunindo dados do setor ${sector.NAME}, aguarde.`, "s");

      } else if(!sector.ID_VALVE) {
        return alert(`Setor ${sector.NAME} não possui válvula associada.`, "e");

      } else if(!sector.VALID_ACTUATOR && sector.IS_MANAGEMENT) {
        return alert(`Atuador ${sector.ACTUATOR_NAME} ainda não possui registros, aguarde.`, "e");

      } else if(!sector.MANAGEMENT || !sector.MANAGEMENT.TIME) {
        return alert(`Altere o setor ${sector.NAME} para manejo e obtenha sugestões de lâmina.`, "e");

      }

      this.openDetailsDialog(sector);
      this.selectedCard = index;
    },
    async monitLoop() {
      const managementSectorsBasic = await management.getSectorsMonitoringSkeleton({ type: 'management' });
      this.totalSectorsCategory = managementSectorsBasic.length;

      const loadingSectors = managementSectorsBasic
        .map(sector => {
          sector.STATUS = ["Calculando"];
          sector.STATUS_COLOR = "bg-grey";
          sector.isLoading = true;
          sector.STATUS_ORDER = this.statusOrderSector.loading;
          sector.FARM = { NAME: sector.FARM_NAME };

          return sector;
        });

        this.fullList = loadingSectors;

      const totalpages = Math.ceil(this.totalSectorsCategory/this.limitSliceRequest);

      if(!this.totalSectorsCategory) {
        return this.loading = false;
      }

      [...Array(totalpages).keys()]
      .map(async i => {
        const page = i + 1;
        const sectorsManagement = await this.getCardsData({page, limit: this.limitSliceRequest});

        sectorsManagement.forEach(sector => this.getStatus({ sector }));

        this.activeSectors.push(...sectorsManagement);

        this.loadedSectorsCategory += sectorsManagement.length;

        const sectorsLoadedId = sectorsManagement.map(sector => sector.ID_SECTOR);
        const fullListRemovingLoadedSectorsCategory = this.fullList.filter(sector => {
          return sectorsLoadedId.findIndex(id_sector => id_sector === sector.ID_SECTOR) < 0;
        })

        this.fullList = [
          ...fullListRemovingLoadedSectorsCategory,
          ...sectorsManagement
        ]

        if(this.loadedSectorsCategory === this.totalSectorsCategory) {
          this.loading = false;
        }

      });

    },
    async getCardsData({page, limit}) {
      return await management.getSectorsMonitoringPage({ page, limit, isCroped: false });
    },
    closeDetails() {
      this.showDetails = false;
      this.selected = null;
      this.selectedCard = null;
    },
    getStatus({sector, isCroped = false}) {
      sector.STATUS = [];

      if(!isCroped && !sector.ID_VALVE) {
        sector.STATUS.push("Sem válvula");
        sector.STATUS_COLOR = "bg-grey";
        sector.STATUS_ORDER = this.statusOrderSector.desatualizado;
        return;
      }

      const mgmt = sector.MANAGEMENT || {};
      const percentageStatusFactor = mgmt.AVAILABILITY;

      const percentage = this.calcPercentageRounded(
        mgmt.FINAL_STORAGE,
        mgmt.MAX_STORAGE
      ) * (0.01);

      const percentageRed = 1 - percentageStatusFactor;
      const percentageYellow = (1 - percentageRed) / 2 + percentageRed;

      const statusUndefined = (percentage != 0 && !percentage) || (!isCroped && mgmt.IS_OUTDATED);
      const statusYellow = percentage <= percentageYellow;
      const statusRed = percentage <= percentageRed;

      let bg = "bg-";
      let status = "";
      let STATUS_ORDER = this.statusOrderSector.desatualizado;

      if (statusUndefined) {
        bg += "grey";
        status = "Desatualizado";
        STATUS_ORDER = this.statusOrderSector.desatualizado;

      } else if(isCroped) {
        bg += "grey";
        status = "Colhido";
        STATUS_ORDER = this.statusOrderSector.colhido;
        
      } else if (statusRed) {
        bg += "red";
        status = "Crítico";
        STATUS_ORDER = this.statusOrderSector.critico;

      } else if (statusYellow) {
        bg += "yellow";
        status = "Abaixo";
        STATUS_ORDER = this.statusOrderSector.abaixo;

      } else {
        bg += "3v3";
        status = "Na faixa";
        STATUS_ORDER = this.statusOrderSector.na_faixa;

      }

      sector.STATUS.push(status);

      if(sector.HAS_SENSOR){
        sector.STATUS.push("Com Sensor");
      }

      if(mgmt.EXCESS && !isCroped ){
        sector.STATUS.push("Excedente");
      }

      sector.STATUS_COLOR = bg;
      sector.STATUS_ORDER = STATUS_ORDER;
    },
    BGRF(stat, update) {
      //comunição
      switch (stat) {
        case 0:
          return "";
        case 7:
          return "";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    loadedSectorsPercentage() {
      return this.totalSectorsCategory ? Number(((this.loadedSectorsCategory)*100/this.totalSectorsCategory).toFixed(1)) : 0;
    },
    options() {
      const sectorsEditorsName = this.fullList
        .filter(sector => sector.EDITOR_NAME)
        .map(sector => sector.EDITOR_NAME)
        .sort((a, b) => a.localeCompare(b))

      const uniqueEditorsName = [...new Set(sectorsEditorsName)];

      // const getEditorsSectorsLength = (editorName) => {
      //   return this.fullList
      //     .filter(sector => sector.EDITOR_NAME === editorName)
      //     .length
      // }

      return uniqueEditorsName
        .map((name) => {
          const nameLimited = name.length > 11? `${name.slice(0,11)}...` : name;

          return {
            text: `${nameLimited}`,
            value: name,
          };
        });
    },
    // Só os cultivares presentes na lista carregada (mesma lógica do filtro de usuários).
    farmOptions() {
      const names = this.fullList
        .filter(sector => sector.FARM && sector.FARM.NAME)
        .map(sector => sector.FARM.NAME)
        .sort((a, b) => a.localeCompare(b));

      return [...new Set(names)].map((name) => ({
        text: name.length > 11 ? `${name.slice(0, 11)}...` : name,
        value: name,
      }));
    },
    itemsSorted() {
      const orderKey = this.selectedSortBy ? this.selectedSortBy : "STATUS_ORDER";

      if(orderKey === "NAME") {
        return this.fullList.sort((a, b) => a[orderKey].localeCompare(b[orderKey]));

      } else {
        return this.fullList.sort((a, b) => a[orderKey] - b[orderKey]);

      }
    },
    itemsShowing() {
      return this.itemsSorted
        .filter(sector => {
          if(!this.searchValue){
            return true;
          }

          return sector.NAME.toUpperCase().includes(this.searchValue.toUpperCase());
        })
        .filter(sector => {
          if(!this.selectedCheckbox.length){
            return true;
          }

          return this.selectedCheckbox.includes(sector.EDITOR_NAME);
        })
        .filter(sector => {
          if(!this.selectedFarmNames.length){
            return true;
          }

          return sector.FARM && this.selectedFarmNames.includes(sector.FARM.NAME);
        })
        .filter(sector => {
          if(!this.sectorsFilters.values.filterStatus){
            return true;
          }
          return sector.STATUS.includes(this.sectorsFilters.values.filterStatus);
        })
        .filter(sector => {
          if(!this.sectorsFilters.values.filterEquipment){
            return true;
          }

          return sector.STATUS.includes(this.sectorsFilters.values.filterEquipment);
        })
    },
    editorName() {
      return this.selected.EDITOR_NAME;
    },
  },
};
</script>
<style scoped>
.wrapper-users-filters >>> .options > * {
  width: 50% !important;
  margin-right: 0 !important;
}
.water-icon-excess {
  color: #2997a8 !important;
}

.monit-sector-main {
  width: 100%;
  transition: 0.1s;
  overflow-y: auto;
  height: 100%;
  margin: 0;
}
.card-icon {
  color: #9e9e9e;
  font-size: 13px;
}
.measure-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EmptyRequest {
  width: 100%;
  padding: 10px;
  color: Black;
  font-size: 1.1rem;
  text-align: center;
}
.my-class {
  padding: 0;
}
.monitCard {
  min-height: 180px;
}
.filter-model {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}

.badge-3v3 {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-3v3 * {
  font-size: 20px;
}
</style>